import { DateTime } from 'luxon';
import { IRecentHiringActivityCardData } from 'modules/hiring/components/recentHiringActivity/recentHiringActivityCard';

export interface IHiringActivity {
  candidateName: string | null;
  activityName: string | null;
  activityStatus: string | null;
  activityDate: string | null;
  jobTitle: string | null;
  jobRequistionId: number | null;
  hiringManagerName: string | null;
  recruiterName: string | null;
}

export interface IRecentHiringActivityResponse {
  candidateActivityHistory: IHiringActivity[];
}

export const mapRecentHiringActivityDataToCardData = (
  data: IHiringActivity[] | undefined,
  recentDaysLimit: number
): IRecentHiringActivityCardData[] => {
  if (!data) return [];

  if (recentDaysLimit) {
    data = data.filter((item) => {
      const activityDate = DateTime.fromISO(item?.activityDate ?? '');
      if (activityDate.isValid) {
        return Math.abs(activityDate.diffNow('days').days) <= recentDaysLimit;
      } else {
        return false;
      }
    });
  }

  return data.map((item) => ({
    name: item?.candidateName ?? '',
    reqId: item?.jobRequistionId?.toString() ?? '',
    activityName: item?.activityName ?? '',
    date: item?.activityDate ?? '',
    activityStatus: item?.activityStatus ?? '',
  }));
};
